import { useParams } from 'react-router-dom';
import { Notification } from 'components/Notification';
import { ContentWrapper } from 'components/layout';
import { useCategory, useUpdateCategory } from 'api/categoryApi';
import { CategoryForm } from './components';
import { useIntl } from 'react-intl';
import { Loading } from 'components/loading';

function normalizeData(data) {
  if (!data) {
    return null;
  }

  const { file, label, name, locale, order, published } = data;

  return {
    name,
    label,
    order,
    locale: locale?.code,
    file: [file],
    published: !!published,
  };
}

export default function ViewCategory() {
  const intl = useIntl();
  const { id } = useParams();
  const { data, isLoading, isFetching } = useCategory({
    id,
  });
  const updateMutation = useUpdateCategory(id);

  const handleSubmit = (values) => {
    updateMutation.mutate(values, {
      onSuccess() {
        Notification(
          'success',
          intl.formatMessage({
            id: `message.updateSuccess`,
          }),
        );
      },
      onError(error) {
        Notification(
          'error',
          error.message ?? intl.formatMessage({ id: 'message.commonError' }),
        );
      },
    });
  };

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (!data) {
    return null;
  }

  return (
    <ContentWrapper title="Chỉnh sửa">
      <CategoryForm
        onSubmit={handleSubmit}
        isLoading={updateMutation.isLoading}
        initialValues={normalizeData(data)}
        relatedEntityId={data.id}
        localizations={data.localizations}
      />
    </ContentWrapper>
  );
}
